export default __webpack_public_path__ + "images/91ee633f09b08220c81d90ee0b3d6284-metal_music.jpg";